var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('span',{staticClass:"font-weight-bold mr-4"},[_vm._v(_vm._s(_vm.label)+":")]),(_vm.value)?_c('span',[_vm._v(" "+_vm._s(_vm.value)+" ")]):_c('span',[_vm._v(" (нет) ")]),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }